<div class="container h-100 page-content" style="padding: 6rem 0;">
    <div class="row mb-4">
        <div class="col">
            <h2>Impressum</h2>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <h4>Diensteanbieter i.S.v. § 5 DDG:</h4>
            <p>
                aheadware GmbH<br />
                Wandelfeld 78<br />
                21407 Deutsch Evern
            </p>
            <h4>Vertreten durch:</h4>
            <p>
                Geschäftsführer: Benjamin Jürgen Schütz
            </p>
            <h4>Kontakt:</h4>
            <p>
                Telefon:	+49-4131-2174060<br />
                Telefax:	+49-4131-2174062<br />
                E-Mail:	hello@aheadware.com
            </p>
            <h4>Registereintrag:</h4>
            <p>
                Eintragung im Handelsregister<br />
                Registergericht:Lüneburg<br />
                Registernummer: 205600
            </p>
            <h4>Umsatzsteuer-ID:</h4>
            <p>
                Umsatzsteuer-Identifikationsnummer gemäß §27 a Umsatzsteuergesetz:<br />
                DE300040029
            </p>
            <h4>Angaben zur Berufshaftpflichtversicherung:</h4>
            <p>
                Name und Sitz der Gesellschaft:<br />
<br />
                exali GmbH<br />
                Franz-Kobinger-Str. 9<br />
                86157 Augsburg<br />
<br />
                Geltungsraum der Versicherung: International
            </p>
            <p>Quelle: <em><a href="http://www.e-recht24.de">http://www.e-recht24.de</a></em></p>
        </div>
    </div>
</div>
